import { API_BASE } from "../../../consts";
import authService from "../../../services/AuthService";

const api = (path, opts) => authService.authenticatedFetch(`${API_BASE}${path}`, opts);

async function handle(resp) {
    const data = await resp.json();
    if (!resp.ok) throw new Error(data.error || `Request failed: ${resp.status}`);
    return data;
}

export const getVacationModeStatus = () =>
    api("/api/walmart/vacation-mode/status").then(handle);

export const prepareVacationMode = () =>
    api("/api/walmart/vacation-mode/prepare", { method: "POST" }).then(handle);

export const cancelVacationMode = () =>
    api("/api/walmart/vacation-mode/cancel", { method: "POST" }).then(handle);

export const activateVacationModePage = (chunkSize = 25) =>
    api("/api/walmart/vacation-mode/activate-page", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chunk_size: chunkSize }),
    }).then(handle);

export const skipFailedVacationMode = () =>
    api("/api/walmart/vacation-mode/skip-failed", { method: "POST" }).then(handle);

export const restoreVacationModePage = (chunkSize = 25) =>
    api("/api/walmart/vacation-mode/restore-page", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chunk_size: chunkSize }),
    }).then(handle);